import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useCallback } from 'react';
import { ThemeContext } from '@emotion/react';
import { darken, getLuminance, lighten, parseToRgb } from 'polished';
import get from 'lodash/get';
import { getColor } from './colors';
import defaultTheme from './default-theme';
export var spacing = 8;
export var fontSizeBase = 16;
export var sizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export var alignTypes = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
export var justifyTypes = {
  center: 'center',
  end: 'flex-end',
  'space-around': 'space-around',
  'space-between': 'space-between',
  'space-evenly': 'space-evenly',
  start: 'flex-start'
};
export function navigateSize(startSize, amount) {
  var index = sizes.indexOf(startSize);
  return sizes[index + amount] || startSize;
}
export function anyDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.some(function (arg) {
    return arg !== undefined && arg !== null;
  });
}
export function spacingValue(value) {
  return typeof value === 'number' ? value * spacing + 'px' : value;
}
export function expandDirectionalProperty(name, value) {
  var values = value.split(/\s+/);

  if (values.length === 1) {
    var _value = values[0];
    values = [_value, _value, _value, _value];
  } else if (values.length === 2) {
    values = values.concat(values);
  } else if (values.length === 3) {
    values.push(values[1]);
  }

  return ['Top', 'Right', 'Bottom', 'Left'].reduce(function (acc, direction, i) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _objectSpread2["" + name + direction] = values[i], _objectSpread2));
  }, {});
}
export function parseSides() {
  for (var _len2 = arguments.length, sides = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    sides[_key2] = arguments[_key2];
  }

  return sides.reduce(function (acc, side) {
    if (typeof side === 'string') {
      return side;
    } else if (side !== null && typeof side !== 'undefined') {
      return side * spacing + 'px';
    }

    return acc;
  }, 0);
}
export function parseColor(color) {
  if (typeof color === 'object') {
    var parsedColor = getColor(color.base) || color.base;

    if (parsedColor === 'transparent') {
      return parsedColor;
    }

    if (color.darken) {
      parsedColor = darken(color.darken, parsedColor);
    }

    if (color.lighten) {
      parsedColor = lighten(color.lighten, parsedColor);
    }

    if (typeof color.alpha !== 'undefined') {
      var _parseToRgb = parseToRgb(parsedColor),
          red = _parseToRgb.red,
          green = _parseToRgb.green,
          blue = _parseToRgb.blue;

      return "rgba(" + red + ", " + green + ", " + blue + ", " + color.alpha + ")";
    } else {
      return parsedColor;
    }
  }

  return getColor(color) || color;
}
export function isLightColor(color) {
  if (color === 'transparent') {
    return null;
  }

  try {
    return getLuminance(parseColor(color)) > 0.5;
  } catch (err) {
    return null;
  }
}
export function getForegroundColor(color) {
  return isLightColor(color) ? 'dark-9' : 'light-9';
}
export function useThemeValue(path, defaultValue) {
  var userTheme = useContext(ThemeContext);
  return path ? get(userTheme, path, defaultValue || get(defaultTheme, path)) : userTheme || defaultTheme;
}
export function useThemeProps(path, props) {
  return _objectSpread(_objectSpread({}, useThemeValue(path)), props);
}
export function useBoxSize(size) {
  if (size === void 0) {
    size = 'md';
  }

  var boxSizes = useThemeValue('boxSizes');
  var navigateSize = useCallback(function (amount) {
    var index = Object.keys(boxSizes).indexOf(size);
    return sizes[index + amount] || size;
  }, [size]);
  return _objectSpread(_objectSpread({}, boxSizes[size] || {}), {}, {
    navigateSize: navigateSize
  });
}